import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconSvg } from '../../../../../../atoms'
import { Modal } from '../../../../../../molecules'

interface IUserCanConfirmAdjustmentsModalProps {
  isOpenModal: boolean
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  onSubmit: () => void
  isLoadingSubmit: boolean
}

const UserCanConfirmAdjustmentsModal = ({
  isOpenModal,
  setIsOpenModal,
  onSubmit,
  isLoadingSubmit,
}: IUserCanConfirmAdjustmentsModalProps) => {
  const intl = useIntl()
  return (
    <Modal
      isOpen={isOpenModal}
      closeModal={() => setIsOpenModal(false)}
      title={intl.formatMessage({
        id: 'ui.ModalConfirmAdjustments.confirmAdjustments',
        defaultMessage: 'Confirmer les ajustements des prestations',
      })}
      className='w-[500px]'
      scrollbarStyle={{ padding: '0px 30px' }}
      footerStyle={{ boxSizing: 'border-box' }}
      footer={{
        button: {
          label: intl.formatMessage({
            id: 'ui.ModalConfirmAdjustments.confirmAdjustments',
            defaultMessage: 'Confirmer les ajustements des prestations',
          }),
          fullWidth: true,
          onClick: () => {
            onSubmit()
          },
          isLoading: isLoadingSubmit,
          disabled: isLoadingSubmit,
        },
      }}
    >
      <div className='flex flex-col items-center gap-4 pb-4 text-sm'>
        <IconSvg.Adjustments color='grey' />
        <div className='flex flex-col gap-3'>
          <p>
            <FormattedMessage
              id='ui.ModalConfirmAdjustments.definitiveConfirmation'
              defaultMessage='Confirmez-vous de manière définitive l’ensemble des prestations ajustées de votre séjour ? En cliquant
				ci-dessous, l’hôte sera notifié des ajustements et aura la possibilité de les confirmer ou de les remettre
				en question.'
            />
          </p>
          <p>
            <FormattedMessage
              id='ui.ModalConfirmAdjustments.ownerConfirmation'
              defaultMessage=' Si l’hôte accepte les ajustements de prestation, votre facture de solde avant séjour sera émise et vous
				serez invité à régler le solde avant séjour.'
            />
          </p>
        </div>
      </div>
    </Modal>
  )
}

export default UserCanConfirmAdjustmentsModal
